import React from "react";
import ReactDOM from "react-dom";
import "./assets/scss/dashlite.scss";
import "./assets/scss/style-email.scss";
import { BrowserRouter as Router, Route } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";



ReactDOM.render(
  <React.Fragment>
      <Router basename={`/`}>
            <Route render={App} />
      </Router>
  </React.Fragment>,
  document.getElementById("root")
);


reportWebVitals();
